<template v-if="plcyList != null">
    <main role="main">
        <article class="layout-contents-container">
            <!-- Title -->
            <div class="layout-page-title lr-grid">
                <h1 class="page-title">
                    {{$t('MENU.POLICY_TEMPLATE')}}
                </h1>
                <button
                    name="button" class="buttons policy-help"  data-type="line"
                    data-size="s" v-on:click="toggleHelp()">
                    {{ $t('POLICY.LABEL.POLICY_TOOLTIP')}}
                </button>
            </div>
            <!-- Title -->
            <div class="layout-contents">
                <fieldset class="tbl-filters">
                    <legend>table filters</legend>
                    <div class="seperate" :key="getLocale" v-if="!reloadOption">
                        <select-box-single
                            select-id="typeFilter"
                            select-class="type-single"
                            :select-box-options="constants.POLICY_TYPE_FILTER"
                            :select-box-value="search.userDefiYn"
                            :use-translate="true"
                            @onSelectChange="search.userDefiYn = $event.value;fnSearching()"/>
                        <SelectBoxMulti
                            select-id="select_vndr"
                            select-class="type-checkbox"
                            place-holder="FILTER.VENDOR_TYPE"
                            :select-box-options="vndrList"
                            :selectBoxValue="slctVndrKeys"
                            @onSelectChange="changeFilterData($event.value)"
                        />
                        <span v-for="(vndr, idx) in slctVendors" :key="idx"
                            :data-vendor="Common.getVendorByKey(vndr)"
                            class="icon-vender" data-size="s"/>
                    </div>

                    <div class="search-box">
                        <input type="search" :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                               v-model="search.srchText"
                               @keyup="debounceFnSearching" class="pr-0">
                        <button v-show="search.srchText !== ''" type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="clear" v-on:click="search.srchText = '';fnSearching()">Reset</button>
                        <button type="button" class="btn-search" @click="fnSearching()">Search</button>
                    </div>

                    <div v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="actions">
                        <button type="button" class="buttons" @click="openAddPlcyPopup">{{ $t('POLICY.BUTTON.CREATE_POLICY')}}<!--정책 생성--></button>
                    </div>

                </fieldset>

                <div class="tbl-collapse" data-linkable-row>

                    <div class="thead">
                        <div class="row">
                            <span class="cell" data-size="auto">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('titl')"
                                        >{{ $t('LABEL.POLICY_NAME')}}</button>
                            </span>
                            <span class="cell" data-size="status02" data-align="center">
                                <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-stat-filter">{{ $t('LABEL.EVAL_STAT')}}</button>
                                <div class="tooltip_templates">
                                    <div id="tooltip-stat-filter">
                                        <ul class="list-filter">
                                            <li v-for="(stat, index) of constants.COMPLIANCE_STAT_FILTER" :key="index">
                                                <input type="checkbox"
                                                       :id="stat.key"
                                                       name="filter-type"
                                                       class="checkbox"
                                                       v-model="cmplStatFilter"
                                                       :value="stat.key"
                                                       @change="changeCmplStatFilter">
                                                <label :for="stat.key">{{$t(stat.val)}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell" data-size="score" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'ruleCnt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('ruleCnt')"
                                        >{{ $t('POLICY.LABEL.APPLIED_RULES')}}</button>
                            </span>
                            <span class="cell" data-size="date" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'updtDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('updtDt')"
                                        >{{ $t('LABEL.UPDATE_DATE')}}</button>
                            </span>
                            <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="add" data-align="center">
                                {{$t('POLICY.LABEL.ADD_TO')}}
                            </span>
                            <span class="cell" data-size="management" data-align="center">
                                {{$t('LABEL.OPTIONS')}}
                            </span>
                            <span class="cell" data-align="center">
                                {{$t('LABEL.DETAILS')}}
                            </span>
                        </div>
                    </div>

                    <div class="tbody">
                        <div class="row" v-for="(plcy, index) in plcyList" :key="index">
                            <div class="cells">
                                <span class="cell" data-size="auto" @click="moveToDetail(plcy, $event)">
                                    <div class="policy-item">
                                        <span class="icon-tag" v-bind:data-type="plcy.userDefiYn === constants.PARAM.SELECT.Y ? 'policy-custom' : 'policy-system'">
                                            {{$t(plcy.userDefiYn === constants.PARAM.SELECT.Y ? 'TYPE.CUSTOM' : 'TYPE.BEST_PRACTICE')}}
                                        </span>
                                            <template v-for="vendor in plcy.vendors">
                                                <span v-bind:key="vendor" :data-vendor="getVendorIcon(vendor)" class="icon-vender txt-none" data-size="m"/>
                                            </template>
                                        <span class="name" v-bind:title="plcy.titl">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Title"] : plcy.titl}}</span>
                                        <span class="desc" v-bind:title="plcy.desc">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Desc"] : plcy.desc}}</span>
                                    </div>
                                </span>

                                <span class="cell" data-size="status02" data-align="center" @click="moveToDetail(plcy, $event)">
                                    <!--성공-->
                                    <span v-if="plcy.execDt != null && plcy.cmplStat === constants.COMPLIANCE_STAT.PASS" class="icon-tag" data-type="success">{{ $t('POLICY.EVAL_STAT.PASS')}}</span>
                                    <!--실패(해결)-->
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === constants.COMPLIANCE_STAT.FAIL && plcy.execYn === constants.PARAM.SELECT.Y" class="icon-tag" data-type="failer">{{ $t('POLICY.EVAL_STAT.FAIL_SOLVED')}}</span>
                                    <!--실패(미해결)-->
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === constants.COMPLIANCE_STAT.FAIL && plcy.execYn === constants.PARAM.SELECT.N" class="icon-tag" data-type="failer">{{ $t('POLICY.EVAL_STAT.FAIL_UNSOLVED')}}</span>
                                    <!--Error-->
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === constants.COMPLIANCE_STAT.ERROR" class="icon-tag" data-type="error">{{ $t('POLICY.EVAL_STAT.ERROR')}}</span>
                                    <!--검사중-->
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === constants.COMPLIANCE_STAT.EXAMINING" class="icon-tag" data-type="waiting" data-icon="examining">{{ $t('POLICY.EVAL_STAT.EXAMINING')}}</span>
                                    <!--미검사-->
                                    <span v-else class="icon-tag" data-type="waiting" data-icon="unexamined">{{ $t('POLICY.EVAL_STAT.UNEXAMINED')}}</span>
                                    <!--Compliance 이-->
                                    <!--<a href="return false" class="buttons-icon" data-type="ghost" data-icon="open" data-size="xs">검사 상세 화면으로 바로가기</a>-->
                                    <router-link tag="button" v-bind:to="'compliance/'+plcy.cmplId+(plcy.rsltId ? '/'+plcy.rsltId : '')" v-if="plcy.execDt"
                                                 class="buttons-icon" data-type="ghost" data-icon="open" data-size="xs">{{ $t('POLICY.BUTTON.GO_TO_ASSESSMENT_DETAIL_SCREEN')}}</router-link>
                                </span>

                                <span class="cell" data-size="score" data-align="center" @click="moveToDetail(plcy, $event)">
                                    <em>{{plcy.ruleCnt}}</em>
                                </span>

                                <span class="cell" data-size="date" @click="moveToDetail(plcy, $event)">
                                    <time datetime="">{{convertUtcTimezoneToLocal(plcy.updtDt)}}</time>
                                </span>
                                <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT"
                                    class="cell"
                                    data-size="add"
                                    data-align="center"
                                    @click="moveToDetail(plcy, $event)">
                                        <button type="button"
                                            class="buttons"
                                            data-type="key"
                                            data-size="s"
                                            @click="openAddSchePopup(plcy)"
                                        >{{ $t('POLICY.BUTTON.ADD_ITEM')}}<!--추가--></button>
                                </span>
                                <span class="cell" data-size="management" data-align="center" @click="moveToDetail(plcy, $event)">
                                    <div class="tooltip-management">
                                        <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="more" v-on:click="toggleManagement($event)" v-on:blur="hideManagement($event)">{{$t('LABEL.MANAGE')}}</button>
                                        <!-- data-show 유/무 -->
                                        <div class="management-contents">
                                            <ul class="list-actions">
                                                <li v-if="getMenuAuth === constants.AUTH_TYPE.EDIT">
                                                    <button type="button" class="btn" data-trigger="" @click="moveToReplica(plcy)">{{ $t('COMMON.BUTTON.CAMEL.COPY')}}<!--복사--></button>
                                                </li>
                                                <li v-if="(plcy.userDefiYn === constants.PARAM.SELECT.Y) && (getMenuAuth === constants.AUTH_TYPE.EDIT)">
                                                    <button type="button" class="btn" data-trigger="" @click="openDeleteModal(plcy)">{{ $t('COMMON.BUTTON.CAMEL.DELETE')}}<!--삭제--></button>
                                                </li>
                                                <li>
                                                    <button type="button" class="btn" data-trigger="" @click="goToHistory(plcy)">{{ $t('POLICY.BUTTON.VIEW_HISTORY')}}<!--히스토리 보기--></button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </span>
                                <span class="cell" data-align="center" @click="moveToDetail(plcy, $event)">
                                    <span class="icon-detail-disclosure">
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="row none with-button" v-if="!pending && (plcyList && plcyList.length === 0)">
                            <div class="cells">
                                <div class="cell">
                                    {{$t('COMMON.NO_DATA')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="paging">
                        <pagination
                            :callSetCurPage="setCurrentPage"
                            :callSetRowsPerPage="setRowsPerPage"
                            :totalPage=paging.totalPage
                            :currentPage=paging.currentPage
                            :rowsPerPage=paging.rowPerPage
                        />
                    </div>
                </div>
            </div>
        </article>
        <div-loading v-if="pending" :full="true"/>
        <Modal
            ref="plcySingleModal"
            :okFunction="handleModalOkFunc"
            :title="modal.popupTitle"
            :message="modal.popupMessage"
            :isShowPopup="modal.isShowPopup"
            :callOnHide="handleHideModal"
            :isOkDisabled="isModalOkDisabled"
            :btnOkStyle="modal.btnOkStyle"
            :modalClass="modal.popupType === 'addSchePopup' ? 'add-sche-popup' : ''"
            :okTitle="modal.okTitle">
            <template
                v-if="modal.popupType === 'addPlcy'"
                v-slot:body-template>
                <AddPolicyForm
                    :callSetNewPolicy="setNewPolicy"
                />
            </template>
            <template
                v-else-if="modal.popupType === 'addSchePopup'"
                v-slot:body-template>
                <AddingSchePopup
                    :callSetScheInfo="setScheInfo"
                    :vendors="tmpPlcy.vendors"
                    :step="step"
                    :callGetStep="callGetStep"
                />
            </template>
        </Modal>
    </main>
</template>

<script>
import {EventBus} from "../common/event-bus";
import Pagination from '../common/Pagination.vue';
import Modal from "../common/Modals/Modal.vue";
import AddPolicyForm from "./policyComponents/AddPolicyForm.vue";
import AddingSchePopup from "./policyComponents/AddingSchePopup.vue"
import {mapGetters, mapMutations} from "vuex";
import SelectBoxMulti from "../common/selectBoxMulti.vue";
import _ from "lodash";

export default {
    name: 'Policy',
    components:{ AddPolicyForm, Pagination, Modal, AddingSchePopup, SelectBoxMulti },
    data() {
        return {
            reloadOption: false,
            dflCtgId: null,
            vndrList: [],
            slctVndrKeys: [],
            selectedPlcyScheInfo: {
                doCmpl: true
            },
            selectedPolicy: {},
            modal: {
                isShowPopup: false,
            },
            newPlcy: {
                titl : '',
                desc : ''
            }, // 새로 등록할 Policy,
            search: {
                userDefiYn: '',
                srchText: ''
            },
            sortColumn: '',                 // Sort column
            sortOrder: '',
            cmplStatFilter: this.constants.PARAM.SELECT.FILTER_ALL,
            plcyList: [],
            tmpPlcy: null, // 항목추가 팝업에서 가지고 있을 Policy 정보

            /* 새 Policy 등록 유효성 검사 */
            pending : false, // API 호출 시 Pending 상태 플래그,
            plcyHistoryList : [], // 폴리시 히스토리 리스트
            //paging
            paging: {
                currentPage: 1,
                rowPerPage: this.constants.NUM.ROW_PER_PAGE,
                totalPage: 0,
                totalItem: 0
            },
            isFirstLoad:false,
            okTitle: this.$t('COMMON.BUTTON.CAMEL.NEXT'),
            okFuncFlag: false,
            step: 1,
            callOkFuncFlag: false,
        }
    },
    created() {
        this.pending = true;
        this.startPolicy();
        this.debounceFnSearching= _.debounce(this.fnSearching, 1000);
        this.debounceSlctPlcyList = _.debounce(this.slctPlcyList, 1000);
        this.$store.dispatch('sse/completeSseEventSource');
    },
    mounted() {
        this.initMultiFilter();
    },
    destroyed: function() {
        // 도움말 닫기
        EventBus.$emit('closeViewPolicyHelp');
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            loginUser: 'user/loginUser',
            policyHistory: 'user/policyHistory',
        }),
        slctVendors() {
            if (this.slctVndrKeys) {
                return this.slctVndrKeys.map(item=>{return item.split('1')[0]});
            }
            return [];

        },
        isModalOkDisabled() {
            if (this.modal.popupType === 'addPlcy') {
                return this.Common.isEmptyText(this.newPlcy.titl) || this.pending;
            } else if (this.modal.popupType === 'deletePlcy') {
                return false;
            } else if (this.modal.popupType === 'addSchePopup') {
                let stepDisabled = this.getStepDisabled();
                return stepDisabled == this.step;
            }
        },
        getMenuAuth: function(){
            //메뉴 별 권한
            let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
            return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
        },
        getLocale: function() {
            return this.$i18n.locale
        }
    },
    watch:  {
        curCmpnId: function() {
            const filterData = {
                currentPage: 1,
            }
            this.getUrlData(filterData);
            this.slctPlcyList(false);
        }
    },
    beforeRouteLeave(to, from, next) {
        let policy = { isRecall: false };
        if (to.name === "PolicyDetail") {
            policy = this.policyHistory;
            policy.isRecall = true;
        }
        this.setPolicyHistory(policy);
        next();
    },
    methods: {
        ...mapMutations({
            setPolicyHistory: "user/setPolicyHistory"
        }),
        async startPolicy() {
            await this.getHistoryInfo();
            await this.debounceSlctPlcyList();
            await this.getVendorData();
        },
        async getVendorData() {
            const url = "/api/governance/dashboard/vendor";
            const header = {
                'cmpnId': this.curCmpnId
            };
            try {
                this.reloadOption = true;
                const response = await this.http.post(url, header);
                if (response.data) {
                    const inUseVendors = response.data;
                    inUseVendors.forEach(vndr => {
                        const vendor = {
                            "key": `${vndr.CLOUD_VNDR_ID}1`,
                            "val": vndr.CLOUD_VNDR_DESC,
                            "vendor": vndr.CLOUD_VNDR_ID == "azu" ? "azure" : vndr.CLOUD_VNDR_ID
                        }
                        this.vndrList.push(vendor);
                    });

                } else {
                    console.error("getVendorData: No Data")
                }
            } catch (err) {
                console.error("getVendorData: ", err);
            } finally {
                this.reloadOption = false;
            }

        },
        changeFilterData(value) {
            this.slctVndrKeys = value;

            this.debounceSlctPlcyList();
        },
        getHistoryInfo() {
            if (this.policyHistory.isRecall) {
                this.getUrlData(this.policyHistory);
            }
        },
        getUrlData(dataFilter) {
            this.reloadOption = true;
            this.cmpnId       = dataFilter.cmpnId;
            this.search.userDefiYn   = dataFilter.userDefiYn;
            this.search.srchText     = dataFilter.srchText;
            this.sortOrder    = dataFilter.sortOrder;
            this.sortColumn   = dataFilter.sortColumn;
            this.isLimitPage = dataFilter.isLimitPage;
            this.statusFilter = dataFilter.statusFilter;
            this.paging.currentPage = dataFilter.currentPage;
            this.paging.totalPage = dataFilter.totalPage;
            this.paging.totalItem = dataFilter.totalItem;
            this.paging.rowPerPage = dataFilter.rowPerPage;
            this.cmplStatFilter = dataFilter.statusFilter;
            this.dflCtgId = dataFilter.dflCtgId;
            this.slctVndrKeys = dataFilter.slctVndrKeys;
            this.reloadOption = false;
        },
        setScheInfo(scheInfo) {
            this.selectedPlcyScheInfo = {...this.selectedPlcyScheInfo, ...scheInfo};
        },
        openAddSchePopup(policy) {
            if (typeof policy.vendorsjs == 'string') {
                policy.vendorsjs = JSON.parse(policy.vendorsjs) || [];
            }
            if (policy.vendorsjs == null || policy.vendorsjs.length == 0) {
                policy.vendorsjs = [];
                this.okFuncFlag = true;
                this.okTitle = this.$t('COMMON.BUTTON.CAMEL.OK');
            }
            this.tmpPlcy = policy;
            this.modal = {
                popupTitle: this.$t('POLICY.ADD_POPUP.POPUP_TITLE'),
                popupMessage: '',
                isShowPopup: true,
                okTitle: this.$t('COMMON.BUTTON.CAMEL.NEXT'),
                popupType: 'addSchePopup'
            }
        },
        setNewPolicy(newPolicy) {
            this.newPlcy = newPolicy;
        },
        changeCmplStatFilter() {
            this.paging.currentPage = 1;
            this.debounceSlctPlcyList();
        },
        setRowsPerPage(rpp) {
            this.paging.currentPage = rpp.currentPage;
            this.paging.rowPerPage = rpp.rowsPerPage;
            this.debounceSlctPlcyList();
        },
        setCurrentPage(e) {
            this.paging.currentPage = e;
            this.slctPlcyList();
        },
        async slctPlcyList(refresh) {
            const url = "/api/governance/policy/list";
            const header = {
                cmpnId:       this.curCmpnId,
                userDefiYn:   this.search.userDefiYn === this.constants.PARAM.SELECT.ALL ? null : this.search.userDefiYn,
                srchText:     this.search.srchText,
                rowPerPage:   this.paging.rowPerPage,
                currentPage:  this.paging.currentPage,
                sortOrder:    this.sortOrder,
                sortColumn:   this.sortColumn,
                isLimitPage:  true,
                statusFilter: this.statusFilter || this.cmplStatFilter,
                slctVendors: this.slctVendors,
                slctVndrKeys: this.slctVndrKeys,
                dflCtgId: this.dflCtgId,
            };
            this.setPolicyHistory(header);
            try {
                if(!refresh) {
                    this.pending = true
                }
                const response  = await this.http.post(url, JSON.stringify(header));
                const data = _.get(response, "data");
                if (data) {
                    this.plcyList = data.result;
                    this.paging = this.setPaging(data.pagination);

                    _.forEach(this.plcyList, function(p){
                        p.vendors = JSON.parse(p.vendorsjs)
                    });
                }
            }catch(err) {
                console.error(err);
            } finally {
                this.pending = false;
            }
        },
        setPaging(pagination) {
            const paging = pagination;
            if (paging.currentPage < 1) {
                paging.currentPage = 1;
            }
            return paging;
        },
        fnSearching() {
            this.paging.currentPage = 1;
            this.slctPlcyList(false);
        },
        setSortColumn: function (sortColumn) {
            if (this.sortColumn !== sortColumn) {
                this.sortColumn = sortColumn;
                this.sortOrder = 'asc';
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'asc') {
                this.sortOrder = 'desc'
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'desc') {
                this.sortColumn = '';
                this.sortOrder = '';
            }
            this.slctPlcyList();
        },
        // 새 Policy 등록
        async insertGovernancePolicy() {
            // Title, Description 에 대한 유효성 검사. 하나라도 invalid 면 return
            if (this.Common.isEmptyText(this.newPlcy.titl) || this.pending) {
                return;
            }
            this.pending = true;
            // reset currentPage
            this.paging.currentPage = 1;
            this.newPlcy.cmpnId = this.curCmpnId;

            const url = "/api/governance/policy";
            const result = await this.http.post(url, JSON.stringify(this.newPlcy));

            if (result.data.status === 'ok'){
                await this.slctPlcyList();
                this.$nextTick(function() {
                    // newPlcy 초기화 및 Popup 닫기
                    this.newPlcy = {};
                    $.magnificPopup.close();
                    EventBus.$emit('toastComment', 'POLICY.TOAST.CREATED_POLICY');
                });
            }
        },
        convertUtcTimezoneToLocal: function(date) {
            return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
        },
        openDeleteModal(plcy) {
            this.selectedPolicy = plcy;
            let popupMessage = this.$t('POLICY.DEL_POPUP.DESC');
            if (plcy.cmplStat === "R") {
                popupMessage = this.$t('POLICY.DEL_POPUP.DESC_BEING_EVALUATED');
            } else if (plcy.cmplId !== null) {
                popupMessage = this.$t('POLICY.DEL_POPUP.DESC_INCLUDED_COMPLIANCE');
            }
            this.modal = {
                popupTitle: this.$t('POLICY.LABEL.DEL_POLICY'),
                popupType: 'deletePlcy',
                popupMessage,
                okTitle: this.$t('COMMON.BUTTON.CAMEL.DELETE'),
                isShowPopup: true,
                btnOkStyle: 'danger'
            }
        },
        handleHideModal() {
            if (this.modal.popupType === 'addPlcy') {
                this.newPlcy = {};
            } else if (this.modal.popupType === 'addSchePopup') {
                if (this.callOkFuncFlag) {
                    if (this.okFuncFlag) {
                        this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
                        this.setScheInfo({doCmpl: true});
                        this.modal.isShowPopup = false;
                        this.okFuncFlag = false;
                        this.step = 1;
                    }
                    this.callOkFuncFlag = false;
                    return;
                }
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
                this.setScheInfo({doCmpl: true});
                this.modal.isShowPopup = false;
                this.okFuncFlag = false;
                this.step = 1;
            }
            this.modal.isShowPopup = false;
        },
        handleModalOkFunc(bvModalEvt) {
            if (this.modal.popupType === 'deletePlcy') {
                this.deletePolicy();
            } else if (this.modal.popupType === 'addPlcy') {
                this.insertGovernancePolicy();
            } else if (this.modal.popupType === 'addSchePopup') {
                this.callOkFuncFlag = true;
                if (this.okFuncFlag) {
                    this.addPlcyToCompliance();
                } else {
                    bvModalEvt.preventDefault();
                    this.step++;
                }
            }
        },
        async addPlcyToCompliance() {
            if (this.pending) return;
            this.pending = true;
            const event = this.selectedPlcyScheInfo;
            const cmpnId = this.curCmpnId;
            const {cmplId, plcyId, rvsnId} = this.tmpPlcy;
            const data = {
                cmpnId,
                cmplId,
                plcyId,
                rvsnId,
                doCmpl: event.doCmpl,
                accounts: event.accounts || [],
                regions: event.regions || []
            };
            if (event.execType === 'A') {
                data.execType = event.execType;
                data.scheInfo = event;
                data.scheInfo.cmpnId = cmpnId;
                data.scheInfo.cmplId = cmplId;
            }
            const url = "/api/governance/policy/apply";
            const response  = await this.http.post(url, data);
            if (response.data.status === 'ok'){
                this.pending = false;
            }
            if(event.doCmpl) {
                await this.changeStatExaming(plcyId);
                await this.autoRefresh();
                this.pending = false;
            } else {
                await this.slctPlcyList();
            }
            EventBus.$emit('addPolicyToCompliance');
        },
        // Policy 삭제
        async deletePolicy() {
            this.pending = true;
            const { cmpnId, plcyId, rvsnId } = this.selectedPolicy;
            const header = {
                cmpnId,
                plcyId,
                rvsnId
            };
            const url = "/api/governance/policy/delete";
            const response = await this.http.post(url, JSON.stringify(header));
            if (response.data.status === 'ok') {
                this.pending = false;
                await this.slctPlcyList(false);
            }
            this.selectedPolicy = null;
        },
        goToHistory(plcy){
            const url = '/audit/detail';
            this.$router.push({path: url, query: {plcy: plcy.plcyId}});
        },
        // Policy 상세 화면으로 이동
        moveToDetail(plcy, $event) {
            if($event.target.nodeName !== 'BUTTON'){
                const url = "/policy/detail"
                this.$router.push({path: url, query: {rvsn: plcy.rvsnId}});
            }
        },
        // Policy 복제 화면으로 이동
        moveToReplica(plcy) {
            const url = "/policy/replica";
            this.$router.push({path: url, query: {rvsn: plcy.rvsnId}});
        },
        openAddPlcyPopup() {
            this.newPlcy = {
                titl : '',
                desc : ''
            };
            this.modal = {
                popupTitle: this.$t('POLICY.POPUP.TITLE.CREATE'),
                popupMessage: this.$t('POLICY.POPUP.DESC.CREATE'),
                isShowPopup: true,
                popupType: 'addPlcy',
                btnOkStyle: 'primary'
            }
        },
        initMultiFilter: function() {

            let $filterTarget = $('.tbl-collapse .buttons-tbl-header[data-type=filter]')

            $filterTarget.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function(instance, helper) {
                    $(helper.origin).addClass("selected");
                },
                functionAfter: function(instance, helper) {
                    $(helper.origin).removeClass("selected");
                },
                functionPosition: function(instance, helper, position) {
                    position.coord.top -= 7;
                    position.coord.left = helper.geo.origin.offset.right - position.size.width;
                    return position;
                }
            });
        },
        toggleManagement: function(event){
            $(event.target).toggleAttr('data-show', '')
        },
        hideManagement: function(event){
            $(event.target).removeAttr('data-show');
        },
        changeStatExaming: function(plcyId){
            let self = this
            _.find(this.plcyList, function(o){
                o.plcyId === plcyId ? o.cmplStat = self.constants.COMPLIANCE_STAT.EXAMINING : false
            })
        },
        autoRefresh: function(){
            const self = this;
            setTimeout(function () {
                self.slctPlcyList(true)
            }, 10000)
        },
        toggleHelp: function(){
            EventBus.$emit('toggleViewPolicyHelp')
        },
         getVendorIcon(value) {
                switch (value.toLowerCase()) {
                case this.constants.VENDOR.AZURE.toLowerCase():
                    return "azure"

                default:
                    return value.toLowerCase();
            }
        },
        callGetStep(step) {
            this.step = step;
            if (step == 3) {
                this.okFuncFlag = true;
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.OK');
            } else {
                this.okFuncFlag = false;
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
            }
        },
        getStepDisabled() {
            let stepDisabled = null;
            if (this.step == 2) {
                let accounts = this.selectedPlcyScheInfo['accounts'] || [];
                if (accounts.length === 0) {
                    stepDisabled = 2;
                }
            }
            if (this.step == 3) {
                let regions = this.selectedPlcyScheInfo['regions'] || [];
                if (regions.length === 0) {
                    stepDisabled = 3;
                }
            }
            return stepDisabled;
        }
    }
}
</script>

<style scoped>
.custom-pagination.-pagination {
    right: 20px;
}
</style>
<style>
.add-sche-popup .modal-body {
    padding: 0 !important;
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policy.vue